<script>
  import { format } from 'svelte-i18n';

  import { ListField } from '@client/components/fields/general';

  import { isValidDomain, isValidEmail } from '@common/utils/validation';

  export let recipients = [];
  export let domains = [];
  export let listFieldError = false;
</script>

<div class="section">
  <div class="campaign-details">
    <div class="campaign-item">
      <div class="campaign-info">
        <b>{$format('label.RECIPIENT_BASED')}</b>
        <p>{$format('label.DESCRIPTION.RECIPIENT_BASED')}</p>
      </div>
      <div class="campaign-actions">
        <ListField
          bind:items={recipients}
          bind:hasErrors={listFieldError}
          validation={isValidEmail}
          validationError={$format('label.VALIDATION_ERROR_EMAIL_ADDRESS')}
          action={$format('label.ADD_EMAIL')}
        />
      </div>
    </div>
    <div class="campaign-item">
      <div class="campaign-info">
        <b>{$format('label.DOMAIN_BASED')}</b>
        <p>{$format('label.DESCRIPTION.DOMAIN_BASED')}</p>
      </div>
      <div class="campaign-actions">
        <ListField
          bind:items={domains}
          bind:hasErrors={listFieldError}
          validation={isValidDomain}
          validationError={$format('label.VALIDATION_ERROR_NO_VALID_DOMAIN_CAMPAIGN')}
          action={$format('label.ADD_DOMAIN')}
        />
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .campaign-actions {
    align-items: center;
    width: 275px;

    :global(.icon-x-circle) {
      margin-right: var(--margin-small);
    }

    :global(.action-button) {
      display: flex;
      justify-content: end;
    }
  }

  :global(.error) {
    color: var(--color-red-500) !important;
    font-size: var(--font-size-medium) !important;
  }
</style>
